import {applyMiddleware, combineReducers} from 'redux';
import MemberReducer from './MemberReducer';
import AgencyReducer from './AgencyReducer';
import NewsGalleryReducer from './NewsGalleryReducer'
import OrderReducer from "./OrderReducer";
import PageReduser from "./PageReduser";
import InsuranceReduser from "./InsuranceReduser";
import IntroReduser from "./IntroReduser";
import thunk from "redux-thunk";
import promise from 'redux-promise';
import settingReducer from './SettingRedusr'
import FilterReduser from "./FilterReduser";
import postType from "./PostReduser";
import token from "./TokenReduser";
export default combineReducers({
  member: MemberReducer,
  agency: AgencyReducer,
  news: NewsGalleryReducer,
  navigation:OrderReducer,
  intro:IntroReduser,
  page:PageReduser,
  InsuranceReduser,
  settingReducer,
  FilterReduser,
  postType,
  token,
});
